//@ts-nocheck
import React, { useState, useEffect, useCallback } from "react";
import { Link, useMatch, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../app/hooks";
import CreateAppReview from "./CreateAppReview";
import CustomMenuDropdown from "../../common/CustomMenuDropdown";
import { format } from "date-fns";
import {
  deleteAppReviewData,
  fetchAppReviewList,
  updateQuestionValue,
} from "../../../features/AppReview/AppReviewSlice";
import { ExclamationIcon } from "../../icons";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { CrossIcon } from "../../icons/Icons";
import { toast } from "sonner";
import Badge from "../../common/Badge";
import { getColorForLabel } from "../../../utils/colorUtils";
import UpdateAppReview from "./UpdateAppReview";
import { _baseRequest, COMMON } from "../../../utils/baseApi";
import ScoreCardApp from "./ScoreCardApp";
import AppReviewDetails from "./AppReviewDetails";
import { fetchQuestionEvaluationStepList } from "../../../features/jobEvaluation/JobApplicationSlice";
export interface FormElementEvaluation {
  id: string;
  type: string;
  label: string;
  icon: string;
  headerText?: string;
  heading?: string;
  placeholder?: string;
  options?: DropdownOption[];
  value?: string;
  required?: boolean;
  step_sequence?: number;
}

function AppReviewSection({
  applicationDetails,
  job: jobProp,
  app: appProp,
  quickData,
  onQuestionnaireAction,
}: any) {
  // const { baseId, jobId, applicationId, skillId } = useParams<{ baseId: string; jobId: string; applicationId: string; skillId: string }>();
  const {
    baseId,
    jobId: jobIdFromParams,
    applicationId: applicationIdFromParams,
    skillId,
  } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
    skillId: string;
  }>();
  const jobId = jobProp || jobIdFromParams;
  const applicationId = appProp || applicationIdFromParams || quickData;

  const dispatch = useAppDispatch();
  const [openMeeting, setOpenMeeting] = useState(false);

  // Local state for meetings data
  const [meetingList, setMeetingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [openDeleteModalExp, setOpenDeleteModalExp] = useState(false);
  const [deleteLoadingExp, setDeleteLoadingExp] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [editMeeting, setEditMeeting] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const [jobRequirement, setJobRequirement] = useState("");
  const [jobRequirementLoading, setJobRequirementLoading] = useState("");
  const [userId, setUserId] = useState(null);
  const [jobRequirementLoading1, setJobRequirementLoading1] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});
  const [jobQuestion, setJobQuestion] = useState([]);
  const [editingValue, setEditingValue] = useState<string>("");
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [selectedMultiDropdown, setSelectedMultiDropdown] = useState<string[]>(
    [],
  );
  const [selectedsingleDropdown, setSelectedsingleDropdown] = useState<
    string[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  const [elements, setElements] = useState<FormElementEvaluation[]>([]);

  // Handler to toggle selection
  const handleMultiDropdownClick = (tagLabel: string, data: any) => {
    const currentAnswers = data.answer
      ? data.answer.split(",").map((s) => s.trim())
      : [];

    let newAnswers;
    if (currentAnswers.includes(tagLabel)) {
      newAnswers = currentAnswers.filter((t) => t !== tagLabel);
    } else {
      newAnswers = [...currentAnswers, tagLabel];
    }

    const newValueString = newAnswers.join(",");

    setJobQuestion((prev) =>
      prev.map((q) => {
        if (q.id === data.id) {
          return { ...q, answer: newValueString };
        }
        return q;
      }),
    );

    handleUpdateQuestionValue(data, newValueString);
  };

  // Pass handler
  const handleSingleDropdownClick = (tagLabel: string, data: any) => {
    // Single select logic is simpler: usually clicking one replaces the previous
    // Or toggles if clicking the same one
    const currentAnswer = data.answer;
    let newAnswer = tagLabel;

    if (currentAnswer === tagLabel) {
      // Optional: Allow deselecting if clicking same item?
      // newAnswer = "";
    }

    // Optimistic Update
    setJobQuestion((prev) =>
      prev.map((q) => {
        if (q.id === data.id) {
          return { ...q, answer: newAnswer };
        }
        return q;
      }),
    );

    handleUpdateQuestionValue(data, newAnswer);
  };

  // Fetch meetings when component mounts
  useEffect(() => {
    if (baseId && applicationId) {
      // Ensure both baseId and appId are available
      setLoading(true);
      dispatch(
        fetchAppReviewList({ baseId: parseInt(baseId), appId: applicationId }),
      ) // Pass an object with baseId and appId
        .unwrap()
        .then((response) => {
          setMeetingList(response.data); // Set the data array from response
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching meetings:", error);
          setError(error.toString());
          setLoading(false);
        });
    }
  }, [dispatch, baseId, applicationId]);

  // useEffect(() => {
  //   if (
  //     applicationDetails &&
  //     Array.isArray(jobQuestion) &&
  //     jobQuestion.length > 0
  //   ) {

  //     setJobQuestion((prev) => {
  //       // Safety check: ensure prev is an array
  //       if (!Array.isArray(prev)) return prev;

  //       const updatedQuestions = prev.map((question) => {
  //         // Ensure appResponse exists and is an array
  //         const response = applicationDetails?.appResponse?.[0];
  //         const ansVal = response
  //           ? response["app_ans" + question.ans_no]
  //           : null;

  //         return {
  //           ...question,
  //           answer: ansVal ? ansVal : null,
  //         };
  //       });
  //       return updatedQuestions;
  //     });
  //   }
  // }, [applicationDetails]);

  useEffect(() => {
    if (applicationDetails?.appResponse?.[0]) {
      setJobQuestion((prevQuestions) => {
        if (!prevQuestions || prevQuestions.length === 0) return prevQuestions;

        const appRes = applicationDetails.appResponse[0];
        return prevQuestions.map((q) => ({
          ...q,
          // Update answer only if we have a value from the DB
          answer: appRes["app_ans" + q.ans_no] || q.answer || null,
        }));
      });
    }
  }, [applicationDetails]);

  const handleMeeting = () => {
    setOpenMeeting(true);
  };

  // const handleMeetingDetails = (meeting: any) => {
  //   navigate(`/${baseId}/job/${jobId}/app/${applicationId}/appreview/${meeting}`)
  // }

  const handleMeetingDetails = (meeting: any) => {
    if (onQuestionnaireAction) {
      // Use the callback provided by parent component
      onQuestionnaireAction(meeting);
    } else {
      navigate(
        `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${meeting}`,
      );
    }
  };

  const handleEvaluationDetails = (meeting: any) => {
    navigate(
      `/${baseId}/job/${jobId}/app/${applicationId}/appevaluation/${meeting}`,
    );
  };
  const handleDeleteClick = (edu, index) => {
    setSelectedIndex(edu); // Store the index to be deleted
    setOpenDeleteModalExp(true); // Open the confirmation modal
  };

  // Function to handle cancel button in delete modal
  const handleCloseModal = () => {
    setOpenDeleteModalExp(false);
    setSelectedIndex(null); // Clear the selected index
  };

  const handleDeleteConfirm = async () => {
    setDeleteLoadingExp(true); // Start loading

    try {
      await dispatch(
        deleteAppReviewData({
          baseId: Number(baseId),
          id: selectedIndex?.id,
        }),
      ).unwrap();

      toast.success("Meeting deleted successfully!");
      setOpenDeleteModalExp(false);
      // setSelectedFile(null)

      const res = await dispatch(
        fetchAppReviewList({
          baseId: Number(baseId),
          appId: applicationId, // Change appID to appId to match the original call
        }),
      ).unwrap();

      if (res.status === 200) {
        setMeetingList(res.data);
      }
    } catch (error) {
      toast.error("Failed to delete meeting!");
      console.error("Delete error:", error);
    } finally {
      setDeleteLoadingExp(false); // Stop loading
    }
  };

  // Ensure selectedMeeting is only updated when necessary
  const handleSelectMeeting = useCallback((meeting) => {
    setSelectedMeeting(meeting);
  }, []);

  const handleEditClick = (meeting) => {
    setSelectedMeeting(meeting);
    setEditMeeting(true);
  };

  //  update internal questionnaire value

  const handleUpdateQuestionValue = async (element, inputValue) => {
    try {
      const res = await dispatch(
        updateQuestionValue({
          data: {
            base_id: baseId,
            job_id: jobId,
            app_id: applicationId,
            question_type: "internal",
            answers: [{ id: element.id, value: inputValue }],
          },
        }),
      ).unwrap();

      setOpenDeleteModalExp(false);
      if (res.status === 200) {
        toast.success("Updated successfully!");
      }
    } finally {
      // setDeleteLoadingExp(false);
    }
  };

  // job requirment list rating
  useEffect(() => {
    const fetchInitialData = async () => {
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${applicationId}/jobRequirement.listAppRatings`;

      try {
        setJobRequirementLoading(true);
        const response = await _baseRequest(fullUrl, "GET");

        if (response.status === 200) {
          setJobRequirement(response?.data);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setJobRequirementLoading(false);
      }
    };

    if (applicationId) {
      fetchInitialData();
    }
  }, [applicationId]);

  // all integration steps details
  // useEffect(() => {
  //   const fetchSteps = async () => {
  //     if (jobId && baseId) {
  //       setIsLoading(true);
  //       try {
  //         const response = await dispatch(
  //           fetchQuestionEvaluationStepList({ baseId, jobId }),
  //         ).unwrap();
  //         console.log("response?.data", response?.data, [response?.data]);
  //         // if (Array.isArray(response?.data)) {
  //         //   const formattedElements = response.data.map((step) => ({
  //         //     ...step,
  //         //     id: step.id || uuidv4(),
  //         //     type: step.type,
  //         //     headerText: step.question,
  //         //     headerDescription: step.description,
  //         //     required: false,
  //         //     options: JSON.parse(step.options || "{}"),
  //         //   }));
  //         setElements([response?.data]);
  //         // } else {
  //         //   console.log("Response is not an array:", response);
  //         // }
  //       } catch (error) {
  //         console.error("Failed to fetch integration steps:", error);
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     }
  //   };
  //   fetchSteps();
  // }, [dispatch, baseId]);

  useEffect(() => {
    const storedUserDetails = JSON.parse(
      localStorage.getItem("userDetails") || "{}",
    );
    setUserId(storedUserDetails?.id); // Assuming the user ID is stored as 'id' in userDetails
  }, []);

  const hasUserRated = (userIds, currentUserId) => {
    if (!userIds || !currentUserId) {
      return false;
    }

    const userIdArray = userIds
      .toString()
      .split(",")
      .map((id) => id.trim());
    return userIdArray.includes(currentUserId.toString());
  };

  // Updated function to handle different background colors for Yes, Maybe, No
  const getBackgroundClasses = (userIds, currentUserId, ratingType) => {
    const hasRated = hasUserRated(userIds, currentUserId);

    if (!hasRated) {
      return "bg-gray-50 ring-1 ring-inset ring-gray-500/10 text-gray-600";
    }

    // Different colors based on rating type
    switch (ratingType) {
      case "yes":
        return "bg-[#f0fdf4] border-green-200 text-[#008236] ring-green-600/20 ring-1 ring-inset";
      case "maybe":
        return "bg-[#fefce8] border-yellow-200 text-[#894b00] ring-yellow-600/20 ring-1 ring-inset";
      case "no":
        return "bg-[#fef2f2] border-red-200 text-[#c10007] ring-red-600/20 ring-1 ring-inset";
      default:
        return "bg-[#fbf9fa] border-gray-200 text-[#4a5565] ring-gray-600/20 ring-1 ring-inset";
    }
  };

  const handleInputChange = (id: number, newValue: string) => {
    setJobQuestion((prev) =>
      prev.map((q) => {
        if (q.id === id) {
          return { ...q, answer: newValue };
        }
        return q;
      }),
    );
  };

  const renderEditableText = (
    element: FormElement,
    index: number,
    field: keyof FormElement,
    label: string,
  ) => {
    const value = element[field] || "";
    const displayText =
      element.label || element.question_input_type || "No Value";

    const handleSave = (e: any) => {
      if (e) {
        handleUpdateQuestionValue(element, e);
      }
    };

    return (
      <div className="flex items-start gap-2 py-2">
        <div className="flex flex-col gap-y-2 w-full">
          <input
            type="text"
            id={`input-${field}`}
            value={element.answer || ""}
            onBlur={(e) => handleSave(e.target.value)}
            onChange={(e) => handleInputChange(element.id, e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleSave(e.target.value);
              }
            }}
            className="block w-full rounded-md border-0 py-1.5 text-[#52555a] text-[13px] shadow-sm ring-1
               h-[36px] ring-inset ring-gray-300 placeholder:text-[#52555a] font-medium focus:ring-2 
               focus:ring-inset focus:ring-indigo-600 sm:leading-6"
          />
        </div>
      </div>
    );
  };

  const renderSingleDropdown = (
    element: FormElement,
    index: number,
    field: keyof FormElement,
    label: string,
    onToggleSelect: (value: string, data: any) => void,
  ) => {
    // Safer parsing logic
    let dropOptions = [];
    try {
      const parsed = JSON.parse(element.question_input_option);
      dropOptions = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      dropOptions = [];
    }
    const currentSelectedValues = element?.answer
      ? element.answer.split(",").map((item) => item.trim())
      : [];

    return (
      <div className="cursor-pointer flex flex-col items-start justify-between gap-2 py-2 relative">
        {/* Added flex-wrap and gap-2 for better layout than margin-left */}
        <div className="flex flex-wrap gap-2 w-full">
          {dropOptions?.map((option, optionIndex) => {
            // Check if this specific option is in the selected array
            const isSelected = currentSelectedValues.includes(option.label);
            return (
              <span
                key={optionIndex + `dropdown`}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent parent div click events
                  onToggleSelect(option.label, element);
                }}
                className={`
                cursor-pointer font-normal text-[13px] capitalize inline-flex items-center rounded-md px-2 py-0.5 border transition-colors duration-200
                ${
                  isSelected
                    ? "bg-indigo-600 text-white ring-1 ring-inset ring-indigo-600/10 border-indigo-600" // Active Styles
                    : "bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10 border-transparent hover:bg-gray-100" // Inactive Styles
                }
              `}
              >
                {option.label}
                {/* Optional: Add a checkmark if selected */}
                {/* {isSelected && <span className="ml-1.5 font-bold">✓</span>} */}
              </span>
            );
          })}
        </div>
      </div>
    );
  };

  const renderDropdownMulti = (
    element: FormElement,
    index: number,
    field: keyof FormElement,
    label: string,
    onToggleSelect: (value: string, data: any) => void,
  ) => {
    // Safer parsing logic
    let dropOptions = [];
    try {
      const parsed = JSON.parse(element.question_input_option);
      dropOptions = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      dropOptions = [];
    }
    const currentSelectedValues = element?.answer
      ? element.answer.split(",").map((item) => item.trim())
      : [];
    return (
      <div className="cursor-pointer flex flex-col items-start justify-between gap-2 py-2 relative">
        {/* Added flex-wrap and gap-2 for better layout than margin-left */}
        <div className="flex flex-wrap gap-2 w-full">
          {dropOptions?.map((option, optionIndex) => {
            // Check if this specific option is in the selected array
            const isSelected = currentSelectedValues.includes(option.label);

            return (
              <span
                key={optionIndex + `multi`}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent parent div click events
                  onToggleSelect(option.label, element);
                }}
                className={`
                cursor-pointer font-normal text-[13px] capitalize inline-flex items-center rounded-md px-2 py-0.5 border transition-colors duration-200
                ${
                  isSelected
                    ? "bg-indigo-600 text-white ring-1 ring-inset ring-indigo-600/10 border-indigo-600" // Active Styles
                    : "bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10 border-transparent hover:bg-gray-100" // Inactive Styles
                }
              `}
              >
                {option.label}
              </span>
            );
          })}
        </div>
      </div>
    );
  };
  const renderElement = (element: FormElement, index: number) => {
    switch (element.question_input_type) {
      case "input":
        return renderEditableText(element, index, "headerText", "Text");
      case "number":
        return renderEditableText(element, index, "headerNumber", "Text");
      case "dropdown":
        return renderSingleDropdown(
          element,
          index,
          "headerText",
          "Dropdown",
          handleSingleDropdownClick,
        );
      case "multi select":
        return renderDropdownMulti(
          element,
          index,
          "Dropdownmulti",
          "Dropdownmulti",
          handleMultiDropdownClick,
        );
      default:
        return null;
    }
  };
  const getUserProfileImage = (userId) => {
    const user = baseMembers.find(
      (member) =>
        member.user_id === userId || member.user_id === Number(userId),
    );
    return user ? user.profile_pic : `User ${userId}`;
  };

  const getUserName = (userId) => {
    const user = baseMembers.find(
      (member) =>
        member.user_id === userId || member.user_id === Number(userId),
    );
    return user ? user.name : `User ${userId}`;
  };

  const getAllUserImages = (userIds) => {
    if (!userIds) return [];

    const userIdArray = userIds
      .toString()
      .split(",")
      .map((id) => Number(id.trim()));

    return userIdArray.map((userId) => {
      const user = baseMembers.find(
        (member) =>
          member.user_id === userId || member.user_id === Number(userId),
      );
      return {
        id: userId,
        name: user ? user.name : `AI`,
        profile_pic: user ? user.profile_pic : null,
        isAI: !user,
      };
    });
  };

  // Helper function to set loading state for specific job and button type
  const setJobLoading = (jobId, buttonType, isLoading) => {
    setLoadingStates((prev) => ({
      ...prev,
      [`${jobId}_${buttonType}`]: isLoading,
    }));
  };

  // Helper function to get loading state for specific job and button type
  const getJobLoading = (jobId, buttonType) => {
    return loadingStates[`${jobId}_${buttonType}`] || false;
  };

  const handleAddRating = async (data) => {
    try {
      setJobLoading(data.id, "yes", true);

      const addRatingUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${
        data?.id
      }/jobRequirement.addRating`;
      const payload = {
        base_id: Number(baseId),
        job_id: jobId,
        app_id: applicationId,
        yes_user_ids: userId.toString(),
      };

      const response = await _baseRequest(addRatingUrl, "POST", payload);
      if (response.status === 200) {
        toast.success("Rating added successfully!");
        // Call fetchInitialData after successful rating addition
        await fetchInitialData();
      }
    } catch (error) {
      console.error("Error adding rating:", error);
    } finally {
      setJobLoading(data.id, "yes", false);
    }
  };

  const handleAddRatingMaybe = async (data) => {
    try {
      setJobLoading(data.id, "maybe", true);

      const addRatingUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${
        data?.id
      }/jobRequirement.addRating`;
      const payload = {
        base_id: Number(baseId),
        job_id: jobId,
        app_id: applicationId,
        maybe_user_ids: userId.toString(),
      };

      const response = await _baseRequest(addRatingUrl, "POST", payload);
      if (response.status === 200) {
        toast.success("Rating added successfully!");
        // Call fetchInitialData after successful rating addition
        await fetchInitialData();
      }
    } catch (error) {
      console.error("Error adding rating:", error);
    } finally {
      setJobLoading(data.id, "maybe", false);
    }
  };

  const handleAddRatingNo = async (data) => {
    try {
      setJobLoading(data.id, "no", true);

      const addRatingUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${
        data?.id
      }/jobRequirement.addRating`;
      const payload = {
        base_id: Number(baseId),
        job_id: jobId,
        app_id: applicationId,
        no_user_ids: userId.toString(),
      };

      const response = await _baseRequest(addRatingUrl, "POST", payload);
      if (response.status === 200) {
        toast.success("Rating added successfully!");
        // Call fetchInitialData after successful rating addition
        await fetchInitialData();
      }
    } catch (error) {
      console.error("Error adding rating:", error);
    } finally {
      setJobLoading(data.id, "no", false);
    }
  };

  // Extracted fetchInitialData function
  const fetchInitialData = async () => {
    const listRatingsUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${applicationId}/jobRequirement.listAppRatings`;

    try {
      setJobRequirementLoading(true);
      const response = await _baseRequest(listRatingsUrl, "GET");

      if (response.status === 200) {
        setJobRequirement(response?.data);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      setJobRequirementLoading(false);
    }
  };

  // Extracted fetchQuestionData function
  useEffect(() => {
    fetchQuestionData();
  }, []);

  const fetchQuestionData = async () => {
    const listUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${jobId}/applicationQuestion.list?question_type=internal`;

    try {
      //setJobQuestionLoading(true);
      const response = await _baseRequest(listUrl, "GET");

      if (response.status === 200) {
        let questions = response.data;

        // Merge immediately if details exist
        if (applicationDetails?.appResponse?.[0]) {
          const appRes = applicationDetails.appResponse[0];
          questions = questions.map((q) => ({
            ...q,
            answer: appRes["app_ans" + q.ans_no] || null,
          }));
        }
        setJobQuestion(questions);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      //setJobQuestionLoading(false);
    }
  };

  const formatDate = (createdAt) => {
    return format(new Date(createdAt), "dd MMM yyyy"); // e.g., "28 May 2025"
  };

  const handleReviewSuccess = (
    currentUserId: string | number,
    reviewId: string | number,
  ) => {
    setOpenMeeting(false);
    setEditMeeting(false);

    if (userId == currentUserId) {
      navigate(
        `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${reviewId}`,
      );
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize">
          Application Review
        </h2>
        <button
          onClick={handleMeeting}
          className="group inline-flex shrink-0 select-none items-center justify-end text-[.8125rem] leading-6 transition-colors 
          duration-100 focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none 
          gap-0 px-[14px] font-medium  py-1 rounded-md text-white bg-indigo-600 h-[32px] hover:bg-indigo-500 focus-visible:outline-indigo-600"
          type="button"
        >
          <div className="flex items-center gap-[6px]">Create App Review</div>
        </button>
      </div>
      {jobRequirementLoading && (
        <div
          className="flex items-center justify-center relative z-50"
          style={{ height: "calc(50vh - 191px)" }}
        >
          <div className="simple-spinner-loader">
            <span></span>
          </div>
        </div>
      )}

      {jobRequirement?.length > 0 && (
        <>
          {/* scorecard */}

          <ScoreCardApp applicationId1={applicationId} />
          <hr className="mt-8 mb-6"></hr>
          <div className="mb-5 gap-x-3">
            <div className="flex items-start flex-col gap-5">
              <div className="flex items-center gap-x-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-clipboard-list w-[1.1rem] h-[1.1rem] text-[#808080]"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                  <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                  <path d="M9 12l.01 0" />
                  <path d="M13 12l2 0" />
                  <path d="M9 16l.01 0" />
                  <path d="M13 16l2 0" />
                </svg>

                <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                  Job requirement
                </span>
              </div>
              <div className="space-y-4 w-full">
                {jobRequirement &&
                  jobRequirement.map((job, index) => {
                    const reviewMaybe = getAllUserImages(
                      job?.app_rating?.maybe_user_ids,
                    );
                    const reviewYes = getAllUserImages(
                      job?.app_rating?.yes_user_ids,
                    );
                    const reviewNo = getAllUserImages(
                      job?.app_rating?.no_user_ids,
                    );

                    // Get individual loading states for this specific job
                    const isYesLoading = getJobLoading(job.id, "yes");
                    const isMaybeLoading = getJobLoading(job.id, "maybe");
                    const isNoLoading = getJobLoading(job.id, "no");

                    return (
                      <div
                        key={index}
                        className="rounded-md p-2 cursor-pointer ring-1 ring-gray-200 feedback-delete-hover"
                      >
                        <div>
                          <span className="text-sm font-medium text-gray-700">
                            {job?.requirement}
                          </span>
                        </div>
                        <hr className="mt-1 mb-0"></hr>
                        <div className="flex items-center gap-2">
                          <div className="flex items-center gap-2 mt-2">
                            <div className="flex items-center gap-2">
                              <span
                                onClick={() =>
                                  !isYesLoading && handleAddRating(job)
                                }
                                className={`flex cursor-pointer items-center gap-[6px] text-[13px] capitalize rounded-md px-2 py-1 
                                                          text-xs font-medium ${getBackgroundClasses(
                                                            job?.app_rating
                                                              ?.yes_user_ids,
                                                            userId,
                                                            "yes",
                                                          )}`}
                              >
                                {isYesLoading ? (
                                  <>
                                    <svg
                                      className="animate-spin h-3 w-3 mr-1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                    >
                                      <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                      ></circle>
                                      <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                      ></path>
                                    </svg>
                                    Yes
                                  </>
                                ) : ("Yes")}
                                {!isYesLoading && (
                                  <>
                                    {job?.app_rating?.yes_rating_count > 0 && (
                                      <>
                                        <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>
                                        <span className="text-xs font-medium text-gray-700">
                                          {job?.app_rating?.yes_rating_count}
                                        </span>
                                      </>
                                    )}

                                    {job?.app_rating?.yes_user_ids && (
                                      <>
                                        <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>

                                        {reviewYes.map((item, index) => {
                                          return (
                                            <div key={index}>
                                              {item?.isAI ? (
                                                // Show SVG for AI
                                                <span
                                                  className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                                  data-title="AI"
                                                >
                                                  <span className="h-4 w-4 flex items-center justify-center rounded-full ring-1 ring-[#ffeab6] bg-[#ffeab6]">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      fill="none"
                                                      viewBox="0 0 24 24"
                                                      strokeWidth="1.5"
                                                      stroke="currentColor"
                                                      className="w-[12px] h-[12px] text-yellow-700"
                                                    >
                                                      <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                                      />
                                                    </svg>
                                                  </span>
                                                </span>
                                              ) : item?.profile_pic ? (
                                                <span
                                                  className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                                  data-title={item?.name}
                                                >
                                                  <img
                                                    src={`${process.env.REACT_APP_API_BASE_URL}/${item?.profile_pic}`}
                                                    alt={`${"Profile"}`}
                                                    className="h-4 w-4 flex-none rounded-full ring-1 ring-gray-900/10"
                                                  />
                                                </span>
                                              ) : (
                                                <span
                                                  className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                                  data-title={item?.name}
                                                >
                                                  <span
                                                    className="bg-[#a3a3a3] flex items-center justify-center h-4 w-4 flex-none rounded-full ring-1
                                                                 ring-gray-900/10 text-white text-[10px] font-medium capitalize line-clamp-1"
                                                  >
                                                    {item?.name
                                                      ?.charAt(0)
                                                      .toUpperCase()}
                                                  </span>
                                                </span>
                                              )}
                                            </div>
                                          );
                                        })}
                                      </>
                                    )}
                                  </>
                                )}
                              </span>
                            </div>
                          </div>

                          {/*  maybe */}

                          <div className="flex items-center gap-2 mt-2">
                            <div className="flex items-center gap-2">
                              <span
                                onClick={() =>
                                  !isMaybeLoading && handleAddRatingMaybe(job)
                                }
                                className={`flex cursor-pointer items-center gap-[6px] text-[13px] capitalize rounded-md px-2 py-1 
                                                          text-xs font-medium ${getBackgroundClasses(
                                                            job?.app_rating
                                                              ?.maybe_user_ids,
                                                            userId,
                                                            "maybe",
                                                          )}`}
                              >
                                {isMaybeLoading ? (
                                  <>
                                    <svg
                                      className="animate-spin h-3 w-3 mr-1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                    >
                                      <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                      ></circle>
                                      <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                      ></path>
                                    </svg>
                                    Maybe
                                  </>
                                ) : (
                                  "Maybe"
                                )}
                                {!isMaybeLoading && (
                                  <>
                                    {job?.app_rating?.maybe_rating_count >
                                      0 && (
                                      <>
                                        <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>
                                        <span className="text-xs font-medium text-gray-700">
                                          {job?.app_rating?.maybe_rating_count}
                                        </span>
                                      </>
                                    )}

                                    {job?.app_rating?.maybe_user_ids && (
                                      <>
                                        <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>
                                        {reviewMaybe.map((item, index) => (
                                          <div key={index}>
                                            {item?.isAI ? (
                                              // Show SVG for AI
                                              <span
                                                className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                                data-title="AI"
                                              >
                                                <span className="h-4 w-4 flex items-center justify-center rounded-full ring-1 ring-[#ffeab6] bg-[#ffeab6]">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth="1.5"
                                                    stroke="currentColor"
                                                    className="w-[12px] h-[12px] text-yellow-700"
                                                  >
                                                    <path
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                                    />
                                                  </svg>
                                                </span>
                                              </span>
                                            ) : item?.profile_pic ? (
                                              <span
                                                className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                                data-title={item?.name}
                                              >
                                                <img
                                                  src={`${process.env.REACT_APP_API_BASE_URL}/${item.profile_pic}`}
                                                  alt="Profile"
                                                  className="h-4 w-4 flex-none rounded-full ring-1 ring-gray-900/10"
                                                />
                                              </span>
                                            ) : (
                                              <span
                                                className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                                data-title={item?.name}
                                              >
                                                <span className="bg-[#a3a3a3] flex items-center justify-center h-4 w-4 flex-none rounded-full ring-1 ring-gray-900/10 text-white text-[10px] font-medium capitalize">
                                                  {item?.name
                                                    ?.charAt(0)
                                                    .toUpperCase()}
                                                </span>
                                              </span>
                                            )}
                                          </div>
                                        ))}
                                      </>
                                    )}
                                  </>
                                )}
                              </span>
                            </div>
                          </div>

                          {/*  no */}

                          <div className="flex items-center gap-2 mt-2">
                            <div className="flex items-center gap-2">
                              <span
                                onClick={() =>
                                  !isNoLoading && handleAddRatingNo(job)
                                }
                                className={`flex cursor-pointer items-center gap-[6px] text-[13px] capitalize rounded-md px-2 py-1 
                                                     text-xs font-medium ${getBackgroundClasses(
                                                       job?.app_rating
                                                         ?.no_user_ids,
                                                       userId,
                                                       "no",
                                                     )}`}
                              >
                                {isNoLoading ? (
                                  <>
                                    <svg
                                      className="animate-spin h-3 w-3 mr-1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                    >
                                      <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                      ></circle>
                                      <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                      ></path>
                                    </svg>
                                    No
                                  </>
                                ) : (
                                  "No"
                                )}
                                {!isNoLoading && (
                                  <>
                                    {job?.app_rating?.no_rating_count > 0 && (
                                      <>
                                        <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>
                                        <span className="text-xs font-medium text-gray-700">
                                          {job?.app_rating?.no_rating_count}
                                        </span>
                                      </>
                                    )}

                                    {job?.app_rating?.no_user_ids && (
                                      <>
                                        <span className="mx-[2px] w-[1px] h-[12px] bg-gray-400 block"></span>

                                        {reviewNo.map((item, index) => {
                                          return (
                                            <div key={index}>
                                              {item?.isAI ? (
                                                // Show SVG for AI
                                                <span
                                                  className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                                  data-title="AI"
                                                >
                                                  <span className="h-4 w-4 flex items-center justify-center rounded-full ring-1 ring-[#ffeab6] bg-[#ffeab6]">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      fill="none"
                                                      viewBox="0 0 24 24"
                                                      strokeWidth="1.5"
                                                      stroke="currentColor"
                                                      className="w-[12px] h-[12px] text-yellow-700"
                                                    >
                                                      <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                                      />
                                                    </svg>
                                                  </span>
                                                </span>
                                              ) : item?.profile_pic ? (
                                                <span
                                                  className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                                  data-title={item?.name}
                                                >
                                                  <img
                                                    src={`${process.env.REACT_APP_API_BASE_URL}/${item?.profile_pic}`}
                                                    alt={`${"Profile"}`}
                                                    className="h-4 w-4 flex-none rounded-full ring-1 ring-gray-900/10"
                                                  />
                                                </span>
                                              ) : (
                                                <span
                                                  className="table-tooltip before:!bottom-[26px] before:!left-[14px]"
                                                  data-title={item?.name}
                                                >
                                                  <span
                                                    className="bg-[#a3a3a3] flex items-center justify-center h-4 w-4 flex-none rounded-full ring-1
                                                                 ring-gray-900/10 text-white text-[10px] font-medium capitalize line-clamp-1"
                                                  >
                                                    {item?.name
                                                      ?.charAt(0)
                                                      .toUpperCase()}
                                                  </span>
                                                </span>
                                              )}
                                            </div>
                                          );
                                        })}
                                      </>
                                    )}
                                  </>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </>
      )}
      <div className="bg-[#e0e0e0] w-full h-[1px] mt-8 mb-6"></div>

      <>
        <div className="mb-5 gap-x-3">
          <div className="flex items-start flex-col gap-5">
            <div className="flex items-center gap-x-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-clipboard-list w-[1.1rem] h-[1.1rem] text-[#808080]"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                <path d="M9 12l.01 0" />
                <path d="M13 12l2 0" />
                <path d="M9 16l.01 0" />
                <path d="M13 16l2 0" />
              </svg>

              <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                Internal
              </span>
            </div>

            <div className="space-y-4 w-full">
              {jobRequirementLoading && (
                <div
                  className="flex items-center justify-center relative z-50"
                  style={{ height: "calc(50vh - 191px)" }}
                >
                  <div className="simple-spinner-loader">
                    <span></span>
                  </div>
                </div>
              )}

              {jobQuestion.length > 0 &&
                jobQuestion.map((element, index) => (
                  <div key={index} className="px-1">
                    <div>
                      <span className="text-sm font-medium text-gray-700">
                        {element?.question_title}
                      </span>
                    </div>
                    {/* <hr className="mt-1 mb-0"></hr> */}
                    {renderElement(element, index)}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </>

      <div className="bg-[#e0e0e0] w-full h-[1px] mt-8 mb-6"></div>

      <div className="flex items-center gap-x-3 mt-6 mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-devices-check w-[1rem] h-[1rem] text-[#808080]"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4" />
          <path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7" />
          <path d="M16 9h2" />
          <path d="M15 19l2 2l4 -4" />
        </svg>

        <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
          Reviews
        </span>
      </div>

      {/* Loading state */}
      {loading && (
        <div
          className="flex items-center justify-center relative z-50"
          style={{ height: "calc(50vh - 191px)" }}
        >
          <div className="simple-spinner-loader">
            <span></span>
          </div>
        </div>
      )}
      {/* Error state */}
      {error && (
        <div className="text-center py-4 text-red-500">Error: {error}</div>
      )}

      {/* No meetings state */}
      {!loading && !error && (!meetingList || meetingList.length === 0) && (
        <div className="w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3">
          <ExclamationIcon />
          <p className="text-[#0000007a] text-[13px]">No results found</p>
        </div>
      )}

      {/* Meeting list */}
      {!loading && !error && meetingList && meetingList.length > 0 && (
        <div className="space-y-4">
          {meetingList.map((meeting, index) => {
            const senderUser =
              baseMembers.find(
                (member) => member.user_id === meeting.review_by,
              ) || {};
            const senderImg = senderUser.profile_pic || null;
            const senderName = senderUser.name || null;
            const formattedDate = formatDate(meeting.updated_at);

            const dropdownGroups = [
              {
                options: [
                  {
                    label: `Edit`,
                    className:
                      "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                    onClick: () => handleEditClick(meeting, index),
                  },
                  {
                    label: `Delete`,
                    className:
                      "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                    onClick: () => handleDeleteClick(meeting, index),
                  },
                ],
              },
            ];

            return (
              <div
                key={meeting.id}
                className="rounded-md  cursor-pointer ring-1 ring-gray-200 feedback-delete-hover"
              >
                <div className="flex items-start px-4 py-4">
                  <div
                    className="flex flex-row w-[82%] gap-x-4 items-start"
                    onClick={
                      meeting.review_by === userId
                        ? () => handleMeetingDetails(meeting.id)
                        : undefined
                    }
                  >
                    <div className="[95%] flex flex-col gap-y-1">
                      {meeting.review_name && (
                        <h2 className="text-sm text-[#374151] font-medium leading-5 mt-[-2px] capitalize">
                          {meeting.review_name}
                        </h2>
                      )}
                      <div className="flex items-center gap-x-2">
                        <div className="">
                          {senderImg ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/${senderImg}`}
                              alt={`${meeting?.review_name || "Profile"}`}
                              className="h-4 w-4 flex-none rounded-full ring-1 ring-gray-900/10"
                            />
                          ) : (
                            <div
                              style={{
                                backgroundColor: getColorForLabel(
                                  meeting?.review_name?.charAt(0) || "",
                                ),
                              }}
                              className="w-4 h-4 rounded-full flex items-center justify-center capitalize"
                            >
                              <span className="font-medium text-white mt-[0px] text-[10px]">
                                {meeting?.review_name?.charAt(0)}
                              </span>
                            </div>
                          )}
                        </div>
                        {senderName && (
                          <div className="text-[12px] text-[#374151] font-medium leading-5 capitalize mt-0">
                            {senderName}
                          </div>
                        )}
                        {meeting.updated_at && (
                          <div className="mx-[0px] w-[1px] h-[12px] bg-gray-400 block"></div>
                        )}
                        {meeting.updated_at && (
                          <span className="text-sm text-gray-500">
                            {formattedDate}
                          </span>
                        )}
                      </div>
                      {/* {
                        dateInfo.fullDate &&
                        <div className='text-xs leading-4 text-gray-500 mt-[2px]'>
                          {dateInfo.fullDate}
                          {
                            dateInfo.time &&
                            <span className='ml-1'>
                              -    {dateInfo.time}
                            </span>
                          }
                        </div>
                      } */}

                      {/* <div className='text-xs leading-4 text-gray-500 mt-1'>Location: {meeting.location || "N/A"}{meeting.location_details ? ` - ${meeting.location_details}` : ""}</div> */}
                    </div>
                  </div>

                  <div className="w-[18%] flex items-start justify-end">
                    <div className=" table-tooltip flex items-center max-w-fit gap-[6px]">
                      {meeting.status === "done" ? (
                        <span
                          className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 capitalize "
                          // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                        >
                          {meeting.status}
                        </span>
                      ) : meeting.status === "pending" ? (
                        <span
                          className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 capitalize"
                          // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                        >
                          {meeting.status}
                        </span>
                      ) : meeting.status === "close" ? (
                        <span
                          className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 capitalize"
                          // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                        >
                          {meeting.status}
                        </span>
                      ) : meeting.status === "cancelled" ? (
                        <span
                          className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 capitalize"
                          // style={{ borderColor: bgColor, borderWidth: 1, borderStyle: 'solid' }}
                        >
                          {meeting.status}
                        </span>
                      ) : meeting.status === "scheduled" ? (
                        <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 capitalize">
                          {meeting.status}
                          {/* completed-payment */}
                        </span>
                      ) : null}
                    </div>
                    {meeting.review_by === userId && (
                      // className="[&>div]:shrink feedback-delete-btn-hover"
                      <div>
                        <CustomMenuDropdown
                          sections={dropdownGroups}
                          icon={
                            <svg
                              stroke="currentColor"
                              fill="none"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              aria-hidden="true"
                              focusable="false"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="12" cy="12" r="1"></circle>
                              <circle cx="12" cy="5" r="1"></circle>
                              <circle cx="12" cy="19" r="1"></circle>
                            </svg>
                          }
                          menuItemsClassName="left-auto"
                        />
                      </div>
                    )}
                  </div>
                </div>

                {meeting.comment && (
                  <div className="px-0">
                    <div className="bg-[#e0e0e0] w-full h-[1px] mb-0"></div>
                    <div className="text-sm text-[#374151] font-normal leading-5 px-4 py-4  whitespace-pre-wrap">
                      {meeting.comment}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* ============================================================== */}

      {/* <div className="bg-[#e0e0e0] w-full h-[1px] mt-8 mb-6"></div>

      <div className="flex items-center gap-x-3 mt-6 mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-devices-check w-[1rem] h-[1rem] text-[#808080]"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4" />
          <path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7" />
          <path d="M16 9h2" />
          <path d="M15 19l2 2l4 -4" />
        </svg>

        <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
          Evaluation
        </span>
      </div>

  
      {loading && (
        <div
          className="flex items-center justify-center relative z-50"
          style={{ height: "calc(50vh - 191px)" }}
        >
          <div className="simple-spinner-loader">
            <span></span>
          </div>
        </div>
      )}

      {error && (
        <div className="text-center py-4 text-red-500">Error: {error}</div>
      )}

 
      {!loading && !error && (!elements || elements.length === 0) && (
        <div className="w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3">
          <ExclamationIcon />
          <p className="text-[#0000007a] text-[13px]">No results found</p>
        </div>
      )}

 
      {!loading && !error && elements && (
        <div className="space-y-4">
          {elements.map((meeting, index) => {
            let assignedUser = Number(meeting.assigned_to);
            const senderUser =
              baseMembers.find((member) => member.user_id === assignedUser) ||
              {};
            const senderImg = senderUser.profile_pic || null;
            const senderName = senderUser.name || null;
            const formattedDate = formatDate(meeting.date);

            const dropdownGroups = [
              {
                options: [
                  {
                    label: `Edit`,
                    className:
                      "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                    onClick: () => handleEditClick(meeting, index),
                  },
                  {
                    label: `Delete`,
                    className:
                      "py-[0.375rem] px-[0.75rem] bg-white text-[#000000eb] text-[13px] hover:bg-[#e7e7e8]",
                    onClick: () => handleDeleteClick(meeting, index),
                  },
                ],
              },
            ];

            return (
              <div
                key={meeting.assignment_id}
                className="rounded-md  cursor-pointer ring-1 ring-gray-200 feedback-delete-hover"
              >
                <div className="flex items-start px-4 py-4">
                  <div
                    className="flex flex-row w-[82%] gap-x-4 items-start"
                    onClick={
                      assignedUser === userId
                        ? () => handleEvaluationDetails(meeting.assignment_id)
                        : undefined
                    }
                  >
                    <div className="[95%] flex flex-col gap-y-1">
                      <h2 className="text-sm text-[#374151] font-medium leading-5 mt-[-2px] capitalize">
               
                        Qestion Assigned
                      </h2>

                      <div className="flex items-center gap-x-2">
                        <div className="">
                          {senderImg ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/${senderImg}`}
                              alt={`${meeting?.review_name || "Profile"}`}
                              className="h-4 w-4 flex-none rounded-full ring-1 ring-gray-900/10"
                            />
                          ) : (
                            <div
                              style={{
                                backgroundColor: getColorForLabel(
                                  meeting?.review_name?.charAt(0) || "",
                                ),
                              }}
                              className="w-4 h-4 rounded-full flex items-center justify-center capitalize"
                            >
                              <span className="font-medium text-white mt-[0px] text-[10px]">
                                {meeting?.review_name?.charAt(0)}
                              </span>
                            </div>
                          )}
                        </div>
                        {senderName && (
                          <div className="text-[12px] text-[#374151] font-medium leading-5 capitalize mt-0">
                            {senderName}
                          </div>
                        )}
                        {meeting.date && (
                          <div className="mx-[0px] w-[1px] h-[12px] bg-gray-400 block"></div>
                        )}
                        {meeting.date && (
                          <span className="text-sm text-gray-500">
                            {formattedDate}
                          </span>
                        )}
                      </div>
                       </div>
                  </div>

                  <div className="w-[18%] flex items-start justify-end">
                    <div className=" table-tooltip flex items-center max-w-fit gap-[6px]">
                      {meeting.status === "done" ? (
                        <span
                          className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 capitalize "
                         >
                          {meeting.status}
                        </span>
                      ) : meeting.status === "pending" ? (
                        <span
                          className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 capitalize"
                           >
                          {meeting.status}
                        </span>
                      ) : meeting.status === "close" ? (
                        <span
                          className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 capitalize"
                         >
                          {meeting.status}
                        </span>
                      ) : meeting.status === "cancelled" ? (
                        <span
                          className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 capitalize"
                          >
                          {meeting.status}
                        </span>
                      ) : meeting.status === "scheduled" ? (
                        <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 capitalize">
                          {meeting.status}
                          
                        </span>
                      ) : null}
                    </div>
                    {meeting.review_by === userId && (
                      <div>
                        <CustomMenuDropdown
                          sections={dropdownGroups}
                          icon={
                            <svg
                              stroke="currentColor"
                              fill="none"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              aria-hidden="true"
                              focusable="false"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="12" cy="12" r="1"></circle>
                              <circle cx="12" cy="5" r="1"></circle>
                              <circle cx="12" cy="19" r="1"></circle>
                            </svg>
                          }
                          menuItemsClassName="left-auto"
                        />
                      </div>
                    )}
                  </div>
                </div>

                {meeting.comment && (
                  <div className="px-0">
                    <div className="bg-[#e0e0e0] w-full h-[1px] mb-0"></div>
                    <div className="text-sm text-[#374151] font-normal leading-5 px-4 py-4  whitespace-pre-wrap">
                      {meeting.comment}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )} */}

      <CreateAppReview
        opneMeeting={openMeeting}
        setOpenMeeting={setOpenMeeting}
        applicationDetails={applicationDetails}
        meetingList={meetingList}
        setMeetingList={setMeetingList}
        quickData={quickData}
        onSuccess={handleReviewSuccess}
      />

      <UpdateAppReview
        opneMeeting={editMeeting}
        setOpenMeeting={setEditMeeting}
        applicationDetails={applicationDetails}
        meetingList={meetingList}
        setMeetingList={setMeetingList}
        selectedMeeting={selectedMeeting}
        quickData={quickData}
        onSuccess={handleReviewSuccess}
      />

      {openDeleteModalExp && (
        <Dialog
          open={true}
          onClose={handleCloseModal}
          className="relative z-10"
        >
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon />
                  </button>
                </div>
                <div className="flex flex-col gay-y-4">
                  <span className="leading-6 text-sm text-gray-500">
                    Do you want to sure delete this App Review?
                  </span>
                </div>
                <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="items-center px-[14px] py-1 text-[13px] font-medium h-[32px] inline-flex leading-6 w-fit justify-center rounded-md bg-white text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDeleteConfirm}
                    type="button"
                    className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 "
                  >
                    {deleteLoadingExp ? (
                      <div className="flex items-center gap-[6px]">
                        Delete
                        <div className="simple-spinner">
                          <span></span>
                        </div>
                      </div>
                    ) : (
                      "Delete"
                    )}
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
}

export default AppReviewSection;
